// Investment assumptions and rate management
import { ref } from 'vue'
import { defaultRateOfReturnValues } from '@/lib/RetirementCalculatorHelper'
import globalConstants from '@/GlobalConstants/globalConstants'
import type { AssumptionValue } from './types'

const gc = globalConstants()

export const useAssumptionsManager = () => {
  const returnValues = defaultRateOfReturnValues()

  // Initialize default assumption values
  const createDefaultAssumptions = () => {
    return {
      inflation: returnValues.inflation,
      wageGrowth: returnValues.wageGrowth,
      insurancePremium: returnValues.insurancePremium,
      annualAdminFees: returnValues.annualAdminFees,
      assumptionValues: returnValues.assumptionValues,
    }
  }

  const updateAssumptionValue = (
    assumptionValues: AssumptionValue[],
    { type, value, label }: { type: string; value: any; label: string }
  ): AssumptionValue[] => {
    return assumptionValues.map((el) => {
      if (el.type === type) {
        // fallback
        el.name = label
        el.rateOfReturn =
          type === 'superFundsDrawDown' && label === 'Starting assumption'
            ? 6.5
            : gc.INVESTMENT_RETURN_PERCENTAGES[value]
        if (el.type.toLowerCase() === 'super')
          el.taxOnEarnings = gc.INVESTMENT_TAX_ON_EARNINGS[value]
      }
      return el
    })
  }

  const updateTaxOnEarnings = (
    assumptionValues: AssumptionValue[],
    { type, value }: { type: string; value: number }
  ): AssumptionValue[] => {
    return assumptionValues.map((el) => {
      if (el.type === type) {
        el.taxOnEarnings = value
      }
      return el
    })
  }

  const updateInvestmentReturn = (
    assumptionValues: AssumptionValue[],
    { type, value }: { type: string; value: number }
  ): AssumptionValue[] => {
    return assumptionValues.map((el) => {
      if (el.type === type) {
        el.rateOfReturn = value
      }
      return el
    })
  }

  const updateAdminFee = (
    assumptionValues: AssumptionValue[],
    { type, value }: { type: string; value: number }
  ): AssumptionValue[] => {
    return assumptionValues.map((el) => {
      if (el.type === type) {
        el.adminFee = value
      }
      return el
    })
  }

  const resetToDefaults = () => {
    return createDefaultAssumptions()
  }

  return {
    createDefaultAssumptions,
    updateAssumptionValue,
    updateTaxOnEarnings,
    updateInvestmentReturn,
    updateAdminFee,
    resetToDefaults,
  }
}